<script setup>
const appConfig = useAppConfig();
</script>

<template>
  <UApp :toaster="appConfig.toaster" :ui="appConfig.ui">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </UApp>
</template>
